import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentDevolutionFetchAction from './equipmentDevolutionFetch.action.json' with { type: 'json' }
import equipmentDevolutionObject from '../equipmentDevolutionObject'
import { equipmentObject } from '~/packages/rural/equipment/equipmentObject'
import { citizenObject } from '~/packages/general/citizen/citizenObject'
import equipmentLoanObject from '~/packages/rural/equipmentLoan/equipmentLoanObject'
import { protocolObject } from '~/packages/general/protocol/protocolObject'

const equipmentDevolutionFetchDefinition = defineAction({
  ...equipmentDevolutionFetchAction,

  input: equipmentDevolutionObject.pick({
    id: true,
  }),
  output: equipmentDevolutionObject.extend({
    equipment: equipmentObject,
    citizen: citizenObject,
    loan: equipmentLoanObject,
    protocol: protocolObject,
  }),
})

export default equipmentDevolutionFetchDefinition
